<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="600px" @close="close">
    <div slot="content">
      <el-form :model="logPolicyInfo" label-position="top" ref="policyForm" :rules="formRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="하이퍼바이저 종류" prop="objtypeId">
              <el-select v-model="logPolicyInfo.objtypeId" style="width: 100%">
                <el-option v-for="type in hypervisorTypeList" :key="type.basicinfoSubid" :value="type.basicinfoSubid" :label="type.basicinfoSubname"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="로그 구분" prop="logPolicyType">
              <el-select v-model="logPolicyInfo.logPolicyType" style="width: 100%">
                <el-option v-for="type in logPolicyTypeList" :key="type.logPolicyType" :value="type.logPolicyType" :label="type.logPolicyName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="정책 명" prop="logPolicyName">
            <el-input v-model="logPolicyInfo.logPolicyName" placeholder="정책명을 입력하세요" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="정책 설명" prop="logPolicyDesc">
            <el-input type="textarea" :rows="3" v-model="logPolicyInfo.logPolicyDesc" placeholder="정책 설명을 입력하세요" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="logFilterCondition">
            <div slot="label" style="display: inline-block">
                <span>필터링 조건 정규 표현식</span>
                <el-popover placement="right" trigger="click" width="400" :offset="40">
                  <el-table height="438px" :data="regexHelpData">
                    <el-table-column v-for="column in regexHelpColumns" :key="column.prop" :label="column.label" :prop="column.prop" :width="column.width"></el-table-column>
                  </el-table>
                  <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
                </el-popover>
            </div>
            <el-input v-model="logPolicyInfo.logFilterCondition" placeholder="정규 표현식을 입력하세요" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="필터링 예외조건 정규 표현식" prop="logXceptFilterCondition">
            <el-input v-model="logPolicyInfo.logXceptFilterCondition" placeholder="예외조건 표현식을 입력하세요" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="조치방법" prop="logSolution">
            <el-input type="textarea" :rows="3" v-model="logPolicyInfo.logSolution" placeholder="조치 방법을 입력하세요" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="정렬순서" prop="orderbyIndex">
            <el-input-number v-model="logPolicyInfo.orderbyIndex" style="width: 50%" controls-position="right" :min="1" :max="999" />
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep, map, isEqual, isEmpty, filter } from 'lodash';
import msgUtil from '@/utils/message';
import basicinfoSubAPI from '@/api/model/basicinfo-sub';
import virtuallogSettingAPI from '@/api/settings/log/virtuallog-settings';

export default {
  name: 'WVirtuallogRuleSettingPopup',
  props: {
    popupParams: {
      type: Object,
    },
  },
  data() {
    const formRules = {
      objtypeId: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
      logPolicyType: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
      logPolicyName: [
        { required: true, message: '필수 정보입니다.', trigger: 'blur' },
      ],
      logFilterCondition: [
        { required: true, message: '필수 정보입니다.', trigger: 'blur' },
      ],
    };
    const regexHelpData = [
      {
        regex: '.*',
        desc: '패턴 안에서 AND 연산',
      },
      {
        regex: '|',
        desc: '패턴 안에서 OR 연산',
      },
      {
        regex: '[^]',
        desc: '\'[]\'안에 있는 문자와 일치하지 않는 문자열을 포함하고 있는 패턴',
      },
      {
        regex: '.',
        desc: '임의의 한 문자',
      },
      {
        regex: '*',
        desc: '바로 앞의 문자가 없거나 하나 이상 반복',
      },
      {
        regex: '+',
        desc: '반드시 하나 이상의 문자가 반복',
      },
      {
        regex: '?',
        desc: '특수문자의 바로 앞의 문자가 하나 있거나 없거나 함',
      },
      {
        regex: '^',
        desc: '문장의 처음',
      },
      {
        regex: '$',
        desc: '문장의 끝',
      },
      {
        regex: '[]',
        desc: '괄호 안의 문자 중 일치하는 것을 찾고자 할 경우',
      },
      {
        regex: '{}',
        desc: '문자나 문자열의 반복되는 개수',
      },
      {
        regex: '()',
        desc: '\'()\'안의 글자들을 하나의 문자로 처리',
      },
    ];

    const regexHelpColumns = [
      { prop: 'regex', label: '정규식', width: '60' },
      { prop: 'desc', label: '설명' },
    ];

    return {
      regexHelpData,
      regexHelpColumns,
      popupTitle: '',
      formRules,
      logPolicyInfo: {
        objtypeId: null,
        logPolicyType: null,
        logPolicyName: null,
        logPolicyDesc: null,
        logFilterCondition: null,
        logXceptFilterCondition: null,
        logSolution: null,
        orderbyIndex: null,
      },
      hypervisorTypeList: [],
      logPolicyTypeList: [],
    };
  },
  methods: {
    open() {
      this.$nextTick(() => {
        const popupType = this.popupParams.popupType;
        this.popupTitle = `로그 정책 ${popupType === 'ADD' ? '추가' : '수정'}`;
        this.logPolicyInfo.orderbyIndex = this.popupParams.orderbyIndex;
        if (popupType === 'UPDATE') {
          this.logPolicyInfo = cloneDeep(this.popupParams.selectedRow);
        }
      });
      this.loadData();
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.initData();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 로그 정책 정보 초기화
     * @author jeee12
     * @return {[type]} [description]
     */
    initData() {
      this.logPolicyInfo = {
        objtypeId: null,
        logPolicyType: null,
        logPolicyName: null,
        logPolicyDesc: null,
        logFilterCondition: null,
        logXceptFilterCondition: null,
        logSolution: null,
        orderbyIndex: 0,
      };
      this.$refs.policyForm.resetFields();
    },
    loadData() {
      basicinfoSubAPI.getList('HYPERVISOR_TYPE').then((response) => {
        if (response.data.success) {
          // VWware와 Hyper-v에서 가상화 로그 수집
          this.hypervisorTypeList = filter(response.data.data, ((e) => e.basicinfoSubid === 'VMWARE' || e.basicinfoSubid === 'HYPERV'));
        }
      });
      virtuallogSettingAPI.getVmsLogPolicyTypeList().then((response) => {
        if (response.data.success) {
          this.logPolicyTypeList = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그 구분', false));
        throw new Error(e);
      });
    },
    /**
     * 저장 버튼 클릭
     * @author jeee12
     * @return {[type]} [description]
     */
    onSaveButton() {
      this.$refs.policyForm.validate().then((success) => {
        if (success) {
          const popupType = this.popupParams.popupType;
          const logPolicyInfo = this.logPolicyInfo;

          if (popupType === 'ADD') {
            virtuallogSettingAPI.addVmsLogPolicy(logPolicyInfo).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '로그 정책', true));
                this.$emit('reload');
                this.close();
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '로그 정책', false));
            });
          } else if (popupType === 'UPDATE') {
            const originLogPolicyInfo = this.popupParams.selectedRow;
            const modifiedInfo = {};
            map(logPolicyInfo, (value, key) => {
              if (!isEqual(originLogPolicyInfo[key], value)) {
                modifiedInfo[key] = value;
              }
            });
            if (!isEmpty(modifiedInfo)) {
              virtuallogSettingAPI.updateVmsLogPolicy({
                logPolicyId: logPolicyInfo.logPolicyId,
                ...modifiedInfo,
              }).then((response) => {
                if (response.data.success) {
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '로그 정책', true));
                  this.$emit('reload');
                  this.close();
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '로그 정책', false));
              });
            }
          }
        }
      }).catch(() => {});
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/Virtuallog/popup/VirtuallogRuleSettingPopup.vue